import { Photo, createPhoto } from '../types/photo';
import { StylistType } from '../types/stylist';

export interface ServiceGroup {
  key: string;
  name: string;
  type: 'category' | 'sub-category' | 'service';
  data: any[];
}

export class Service {
  id: number = 0;
  key: string = '';
  name: string = '';
  description: string = '';
  price?: number;
  duration: number = 0;
  photos?: Photo[];
  canPerform: boolean = false;
  isPriceUp: boolean = false;

  // booking fields
  category: string = '';
  categoryKey: string = '';
  subCategory: string = '';
  subCategoryKey: string = '';
  stylistId?: number;
  stylistName: string = '';

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createService(blob: any, checkCanPerform?: boolean): Service {
  const photos = (blob.photo_link || []).map(createPhoto);

  return new Service({
    id: blob.id,
    key: blob.key,
    name: blob.name,
    description: blob.description,
    price: Number(blob.price_info),
    duration: blob.time_info ? Number(blob.time_info) : 0,
    photos,
    canPerform: checkCanPerform ? !!blob.can_perform : true,
    isPriceUp: !!blob.price_up,

    // booking fields
    category: blob.category,
    categoryKey: blob.categoryKey,
    subCategory: blob.subCategory,
    subCategoryKey: blob.subCategoryKey,
    stylistId: StylistType.NoUser,
    stylistName: '',
  });
}

export function createServiceFromBookingDetail(blob: any): Service {
  return new Service({
    id: Number(blob.service_id),
    name: blob.service_name,
    price: Number(blob.service_price),
    duration: blob.service_duration ? Number(blob.service_duration) : 0,

    stylistId: Number(blob.stylist),
    stylistName: blob.stylistName,
  } as any);
}
